import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "addPic",
  "use": "addPic-usage",
  "viewBox": "0 0 16 13.296",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 13.296\" id=\"addPic\"><defs><style>#addPic .cls-1{fill:rgba(0,0,0,.45)}</style></defs><path id=\"addPic_路径_1241\" data-name=\"路径 1241\" class=\"cls-1\" d=\"M1456.923 912.865h-12a2.006 2.006 0 0 0-2 1.937v9.51a1.922 1.922 0 0 0 1.987 1.849h12.027a1.921 1.921 0 0 0 1.987-1.849V914.8a2.006 2.006 0 0 0-2.001-1.935zm-13.007 1.937a1.042 1.042 0 0 1 1.007-1.007h12a1.042 1.042 0 0 1 1.007 1.007v3.643h-.007v1.4l-3.314-3.082a.514.514 0 0 0-.689 0l-4.161 3.87-1.847-1.718a.513.513 0 0 0-.689 0l-3.3 3.07v-3.541h-.007zm12.915 10.434h-11.816a1.064 1.064 0 0 1-1.092-.936v-1.054a.485.485 0 0 0 .093-.066l3.552-3.3 1.847 1.718a.513.513 0 0 0 .689 0l4.161-3.87 3.658 3.4v3.172a1.064 1.064 0 0 1-1.092.936z\" transform=\"translate(-1442.923 -912.865)\" /><circle id=\"addPic_椭圆_44\" data-name=\"椭圆 44\" class=\"cls-1\" cx=\"1.282\" cy=\"1.282\" r=\"1.282\" transform=\"translate(2.306 2.518)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/addPic.svg
// module id = FTm9
// module chunks = 6